import * as ccPhone from '../util/countryCodesPhone';
import React from 'react';
import classHelper from '../util/class.helper'
import { FormGroup, Col, Row, FormControl, InputGroup } from 'react-bootstrap';
import Select from 'react-select';
import './style.scss';
import NPHelpButton from '../NPHelpButton';

function TelephoneNumber(props) {
    const { setCc, setNumber, countryCode, phoneNumber } = props;

    const helpNode = (
        <div>
          <h4>Mobile number input for two factor authentication</h4>
          <br/>
          <b>Country code</b>
          <p>Choose the corresponding country and country code for your receiving phone number.</p>
          <br/>
          <b>Phone number</b>
          <p>Input the full phone number without any brackets.</p> 
          <p>Only numbers, spaces and dashes are allowed.</p>
        </div>
    );

    function getDefaultCc(cc){
        if(cc == undefined || cc == null){
            return undefined;
        }
        else{
            return ccPhone.codeList.find(x => x.value == cc);
        }
    }

    function isValid(cc){
        if(cc){
            return ((countryCode == undefined || countryCode == null) && (phoneNumber == undefined || phoneNumber == null)) || (countryCode != null);
        }
        else{
            let regex = /^[0-9 -]+$/g;
            let found = phoneNumber != undefined && phoneNumber != null ? phoneNumber.match(regex) : null;
            return ((countryCode == undefined || countryCode == null) && (phoneNumber == undefined || phoneNumber == null)) || (found && phoneNumber != null && phoneNumber.length > 0);
        }
    }
    
    return (
        <FormGroup controlId="form2Selects" bsSize="small" className="margin-left-10 select">
            <Row style={{'margin': '-5px 0px 5px 15px'}} ><NPHelpButton content={helpNode} title="Help" /></Row>
            <Col sm={6}>
                <InputGroup>
                    <InputGroup.Addon>Country code</InputGroup.Addon>
                    <div className={isValid(true) ? "" : "divCustomSelect"}>
                    <Select 
                        placeholder={"Country code"}
                        styles={classHelper.dropdownStyleLarge()}
                        isClearable={false}
                        options={ccPhone.codeList}
                        onChange={evt => { setCc(evt.value); }}
                        value={getDefaultCc(countryCode)}
                    />
                    </div>
                </InputGroup>
            </Col>
            <Col sm={6}>
                <InputGroup>
                    <InputGroup.Addon>Mobile number</InputGroup.Addon>
                    <FormControl
                        className={isValid(false) ? "" : "customSelect"}
                        bsSize="sm"
                        componentClass={"input"}
                        style={{ height: '38px' }}
                        placeholder={"Phone number"}
                        pattern="[0-9 -]*"
                        maxLength={30}
                        value={phoneNumber}
                        onChange={evt => { setNumber(evt.target.value) }}
                    />
                </InputGroup>
            </Col>
        </FormGroup>
    );
}

export default TelephoneNumber;